
const appdata = {
    reg : {
        "firstname": "",
        "lastname": "",
        "email": "",
        "phone": "",
        "username": "",
        "password": "",
        "passwordconfirmation": "",
        "hasaccount" :  {label: "", value: null, index: 0},
        "agreed" : null
    },
    international : {
        company: {
            name: "",
            streetaddress : "",
            city : "",
            state : "",
            postcode : "",
            country : { value : "" , label : "" }
        },
        agent: {
            agentCode:"", //0235151
            cassCode:"", //2122
            company: {
                name: "",
                streetaddress : "",
                city : "",
                state : "",
                postcode : "",
                country : { value : "" , label : "" }
            }
        }

    },
    domestic : {
        'new' : {
            customer : {
                streetaddress : "",
                city : "",
                state : "",
                postcode : "",
                country : { value : "" , label : "" }
            },
            company : {
                city : "",
                state : "",
                postcode : "",
                country : { value : "" , label : "" }
            }
        },
        existingcustomer: {
            company : {
                valid : false ,
                customerCode : "", accountNumber: "",  streetaddress:"",city:"",state:"",postcode:"",
                country : { value : "" , label : "" }}
        },
        groundhandler: {
            company : {
                valid : false ,
                customerCode : "" , accountNumber : "" ,streetaddress:"",city:"",state:"",postcode:"",
                country : { value : "" , label : "" }}
        },
    },
    existingcompany : {
        colleague : {
            username : ""
        },
        name: "",
        streetaddress : "",
        city : "",
        state : "",
        postcode: "",
        country : { value : "" , label : "" }
    }

};

const data = appdata;

const InitialState = {
    registration : data.reg,
    international: data.international,
    domestic: data.domestic,
    existingcompany : data.existingcompany ,
    account : {
        shipping : {value : "", label : ""},
        customer : {value : "", label : ""}
    }
};


export default InitialState